/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * E4 Cards — computed local pickup ETA.
 *
 * Orders are pulled at 9:00 a.m. Tuesday–Friday; pickup opens at 2:00 p.m.
 * those days. An order placed before 9:00 a.m. on a pull day makes that day's
 * pull and is ready the same day; otherwise it rolls to the next pull day.
 *
 * CUTOFF_HOUR and PULL_DAYS must stay in sync with
 * docs/email/order-confirmation-pickup.liquid (the Order confirmation
 * notification template). Changing one without the other desyncs the product
 * page from the email the customer receives.
 *
 * Source of truth: e4-staff-tools docs/theme/pickup-eta.js
 */
(function () {
  var CUTOFF_HOUR = 9;
  var PULL_DAYS = [2, 3, 4, 5]; // 0=Sun, 1=Mon, ... 6=Sat
  var STORE_TZ = 'America/Los_Angeles';
  var DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var SHORT_DAYS = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

  // Whole days from `dow` until the pull that will fill an order placed at `hour`.
  function daysUntilPull(dow, hour) {
    for (var i = 0; i <= 7; i++) {
      var candidate = (dow + i) % 7;
      if (PULL_DAYS.indexOf(candidate) === -1) continue;
      if (i === 0 && hour >= CUTOFF_HOUR) continue; // today's pull already went out
      return i;
    }
    return 0; // unreachable: PULL_DAYS is non-empty, so a hit lands within 7 days
  }

  // "today" | "tomorrow" | "Tuesday"
  function readyWhen(dow, hour) {
    var add = daysUntilPull(dow, hour);
    if (add === 0) return 'today';
    if (add === 1) return 'tomorrow';
    return DAY_NAMES[(dow + add) % 7];
  }

  // Current weekday + hour in the store's timezone, never the shopper's.
  function storeNow(date) {
    var parts = {};
    new Intl.DateTimeFormat('en-US', {
      timeZone: STORE_TZ,
      weekday: 'short',
      hour: 'numeric',
      hour12: false
    }).formatToParts(date || new Date()).forEach(function (part) {
      parts[part.type] = part.value;
    });
    return {
      dow: SHORT_DAYS[parts.weekday],
      hour: parseInt(parts.hour, 10) % 24 // some engines render midnight as "24"
    };
  }

  function render(root) {
    var nodes = (root || document).querySelectorAll('[data-e4-pickup-eta]');
    if (!nodes.length) return;

    var now = storeNow();
    if (now.dow === undefined || isNaN(now.hour)) return; // leave the fallback copy in place

    var when = readyWhen(now.dow, now.hour);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var text = el.getAttribute('data-e4-pickup-eta') === 'short'
        ? 'ready ' + when + ' after 2 p.m.'
        : 'Pick up in store ' + when + ' after 2 p.m.';
      // Writing textContent replaces the child text node, which the observer
      // below would see as a childList mutation. Only write on a real change.
      if (el.textContent !== text) el.textContent = text;
    }
  }

  window.e4PickupEta = { daysUntilPull: daysUntilPull, readyWhen: readyWhen, render: render };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { render(); });
  } else {
    render();
  }

  // Warehouse re-renders the product block on variant change, and injects the
  // quick-view via innerHTML — an inline <script> in the snippet would not run.
  document.addEventListener('variant:changed', function () { render(); });

  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.matches('[data-e4-pickup-eta]') || node.querySelector('[data-e4-pickup-eta]')) {
          render();
          return;
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
